export const METRIKA_COUNTER_ID = Number(process.env.PUBLIC_METRIKA_COUNTER_ID);

export enum AnalyticsGoal {
	/** API подтвердил создание проекта. */
	ProjectCreated = "project_created",
	/** Гость выбрал пустой временный проект. */
	EmptyProjectStarted = "empty_project_started",
	/** В пустом плане появилась первая стена. */
	FirstWallCreated = "first_wall_created",
	/** Новая кухня впервые добавлена в каталог; сохранение на сервере ещё не подтверждено. */
	KitchenCreated = "kitchen_created",
	/** Нажата основная кнопка перехода в планировщик. */
	PlannerCtaClicked = "planner_cta_clicked",
	/** Нажата кнопка конструктора кухни на посадочной странице. */
	KitchenCtaClicked = "kitchen_cta_clicked",
	/** Нажата кнопка конструктора шкафа на посадочной странице. */
	WardrobeCtaClicked = "wardrobe_cta_clicked",
}

export enum UtmParameter {
	Source = "utm_source",
	Medium = "utm_medium",
	Campaign = "utm_campaign",
	Content = "utm_content",
	Term = "utm_term",
}

const CAMPAIGN_KEY = "gridplanner:campaign";
const CAMPAIGN_FIELDS = Object.values(UtmParameter);

type Campaign = Partial<Record<UtmParameter, string>>;

export const captureCampaign = (search: string) => {
	const params = new URLSearchParams(search);
	const campaign: Campaign = {};
	for (const field of CAMPAIGN_FIELDS) {
		const value = params.get(field)?.trim();
		if (value) campaign[field] = value.slice(0, 160);
	}
	if (Object.keys(campaign).length === 0) return;
	try {
		window.sessionStorage.setItem(CAMPAIGN_KEY, JSON.stringify(campaign));
	} catch {
		return;
	}
};

const currentCampaign = (): Campaign => {
	try {
		const value: unknown = JSON.parse(window.sessionStorage.getItem(CAMPAIGN_KEY) ?? "{}");
		if (typeof value !== "object" || value === null || Array.isArray(value)) return {};
		const campaign: Campaign = {};
		for (const field of CAMPAIGN_FIELDS) {
			const entry = (value as Record<string, unknown>)[field];
			if (typeof entry === "string" && entry.length > 0) campaign[field] = entry.slice(0, 160);
		}
		return campaign;
	} catch {
		return {};
	}
};

export const trackGoal = (goal: AnalyticsGoal) => {
	const campaign = currentCampaign();
	try {
		window.ym?.(METRIKA_COUNTER_ID, "reachGoal", goal, campaign);
	} catch {}
	try {
		window.dataLayer?.push({ event: goal, ...campaign });
	} catch {}
};
